/*
 * 1DS JS SDK Web Analytics plugin, 3.2.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Constants.ts
* @author Ram Thiru (ramthi) and Hector Hernandez(hectorh)
* @copyright Microsoft 2018
*/
export var COMMON_SCHEMA_VER = "2.1";
export var MSCONTENT_PARTB_VERSION = "1.0";
export var CONTENT_VERSION = "2.0";
export var MAX_CONTENTNAME_LENGTH = 200;
export var IS_SENSITIVE_FLAG = 0x080000;
export var APPID_PREFIX = "JS:";
//# sourceMappingURL=Constants.js.map